import Checkbox from './Checkbox';
export default Checkbox;
//# sourceMappingURL=index.js.map